// Browser IANA time zone sent with signup forms (Rob, 2026-10-21).
//
// Node stores it as user.signupTimeZone so the AI welcome call stays inside
// legal calling hours. A VPN does not change it, which makes it the strongest
// zone signal we have. Node validates it; this only reads it and never throws.
export function getBrowserTimeZone(): string | undefined {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
}
